import { render, staticRenderFns } from "./RH.vue?vue&type=template&id=68964a1a&"
import script from "./RH.vue?vue&type=script&lang=js&"
export * from "./RH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports